import { createStyles, makeStyles, Theme } from '@material-ui/core';

export const MediaStyles = makeStyles(({ palette, breakpoints }: Theme) => createStyles({
  root: {
    border: 'solid 1px #D5DDE0',
    '&:hover': {
      boxShadow: '0px 2px 4px -1px rgba(0,0,0,0.2), 0px 4px 5px 0px rgba(0,0,0,0.14), 0px 1px 10px 0px rgba(0,0,0,0.12)',
    },
    maxWidth: 300,
    maxHeight: 300,
    width: '100%',
    height: '100%',
    margin: 'auto',
  },
  title: {
    padding: '0 10px',
  },
  mediaContainer: {
    borderBottom: 'solid 1px #D5DDE0',
    textAlign: 'center',
    background: '#F1F2F5',
    height: 200,
    width: '100%',
  },
  mediaContainerBottom: {
    alignItems: 'flex-end',
  },
  media: {
    maxWidth: '100%',
    maxHeight: '100%',
  },
  icon: {
    height: 24,
    verticalAlign: 'middle',
    marginRight: 10,
    width: 'unset',
  },
  imageIcon: {
    color: '#3B9ED8',
  },
  videoIcon: {
    color: '#00AD8D',
  },
  audioIcon: {
    color: '#8324B2',
  },
  titleIcon: {
    color: '#747C99',
    height: 48,
    verticalAlign: 'middle',
    width: 'unset',
  },
  fileIcon: {
    color: '#EFC400',
  },
  lockIcon: {
    verticalAlign: 'middle',
    height: 18,
    color: '#26325F',
  },
  inputUnderline: {
    '&:before': {
      borderBottomColor: palette.input.borderBottomColor,
      [breakpoints.up('sm')]: {
        borderBottomColor: 'transparent',
      },
    },
    '&&:hover:before': {
      borderBottomColor: palette.input.borderBottomColor,
    },
    '&:after': {
      borderBottomColor: palette.menuAction.selected,
    },
  },
  actionIcon: {
    height: 16,
    color: palette.icons.default,
  },
  deleteIcon: {
    color: palette.icons.delete,
  },
  actionButton: {
    minWidth: 40,
    minHeight: 40,
    height: '100%',
    borderRadius: '50%',
    '&:hover': {
      borderRadius: '50%',
    },
  },
  whiteBackground: {
    background: '#FFF',
  },
  renderStatus: {
    padding: '0 16px',
    fontSize: 14,
    color: '#515B6A',
  },
  renderStatusError: {
    marginTop: 20,
    marginBottom: 27,
  },
  loader: {
    '& *': {
      animationDuration: '1.5s !important',
      WebkitAnimationDuration: '1.5s !important',
    },
  },
  completeIcon: {
    fontSize: 20,
    color: '#00AD8D',
    verticalAlign: 'middle',
    margin: '0px 10px',
  },
  errorIcon: {
    height: 48,
    width: 48,
    color: '#F8221A',
  },

  settingPanel: {
    '& .update-date': {
      marginLeft: '8px',
      cursor: 'pointer',
    },
  },
  tooltip: {
    backgroundColor: '#515B6A',
    fontSize: '0.7rem',
  },

  mediaImageContainer: {
    position: 'relative',
    width: '100%',
    height: 'fit-content',

    '& .duration': {
      position: 'absolute',
      right: 0,
      bottom: '1px',
      padding: '3px 12px',
      fontSize: '0.75rem',
      backgroundColor: 'rgba(0,0,0,0.5)',
      color: '#fff',
    },
  },
}), { name: 'MediaDocument' });
